import { render, staticRenderFns } from "./HomeAnnouncementList.vue?vue&type=template&id=44b47578&scoped=true"
import script from "./HomeAnnouncementList.vue?vue&type=script&lang=js"
export * from "./HomeAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./HomeAnnouncementList.vue?vue&type=style&index=0&id=44b47578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.103.0__lodash@4.17.21_2265jmbezkun34f67h53nems6y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b47578",
  null
  
)

export default component.exports